import React, { useState,useContext } from "react";

import MainTitle from "components/MainTitle";
import Fieldset from "components/Fieldset";
import Legend from "components/Legend";
import InputControl from "components/InputControl";
import FormActions from "components/FormActions";
import Button from "components/Button";
import Input from "components/Input";
import Timer from "components/Timer";
import GenericModal from "components/GenericModal";
import { Heading, Link, LinkDetails, Radio, Text } from "mondrian-react";
import { Div } from "components/InputControl/InputControl";
import { TagTypeGa4 } from "core/Utils/Analytics/tagType";
import { getJsonTag} from "core/Utils/Analytics/tagService";
import  tagAdapter from "core/Utils/Analytics/tagAdapter";
import { store } from "store.js";
const styledP = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};
const styledI = {
  marginRight: '5px',
};



const TokenValidate = ({ title, description, onResendToken, onSubmit }) => {


  const [token, setToken] = useState('');
  const [inputError, setInputError] = useState('');
  const [validForm, setValidForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isDisabled, setDisabled] = useState(true);
  const globalState = useContext(store);
  const { state } = globalState;
  const {currentStep= "validar-token"}  = state.analytics;
  const nomeModal  = "aviso_area_meu_perfil";

  const defaultConfig={"nome_modal":nomeModal,type:TagTypeGa4.BUTTON_MODAL}
  function tokenValidate(value) {
    setToken(value);
    if (value.length === 6) {
      setValidForm(true);
      setInputError('');
    } else {
      setInputError('Insira exatamente 6 caracteres numéricos');
      setValidForm(false);
    }
  }

  function handleValidateToken(e) {
    e.preventDefault();
    //this.props.sessionCallback(e.target.clearsale.value);
    onSubmit(token);
  }

  function handleResendToken(e) {
    e.preventDefault();
    onResendToken(token);
    setDisabled(true);
  }

  function handleCloseModal() {
  

    setShowModal(false);
  }

  function handleOpenModal(ev) {
    ev.preventDefault();
    setShowModal(true);
    tagAdapter({"nome_item":ev?.target?.textContent,"nome_secao":currentStep},TagTypeGa4.BUTTON)
  }

  function handleSubmit() {
    window.location.href = process.env.REACT_APP_MY_PROFILE_URL;
  }

  return (
    <>
      <form onSubmit={handleValidateToken}>
        <MainTitle sm>{title}</MainTitle>
        <Legend>
          <Text>{description}</Text>
        </Legend>
        <Fieldset>
          <InputControl>
            <Input
              label="Insira o código aqui"
              tabIndex="20"
              name="inputToken"
              id="inputToken"
              mask={'999999'}
              type="text"
              onlyNumbers={true}
              maskChar=""
              onChange={(e) => tokenValidate(e.target.value)}
              error={inputError}
            />
          </InputControl>
          <InputControl>
            <LinkDetails
              onClick={(ev) => handleOpenModal(ev)}
              className="NotRecognized"
              data={[
                {
                  title: 'Não reconhece seus dados?',
                  description: 'Acesse e siga para recuperar seu perfil',
                  href: '#',
                  linkProps: {
                    tabIndex: 21,
                  },
                },
              ]}
            />
          </InputControl>
          <FormActions>
            <Button
              tabIndex="22"
              type="submit"
              className="mdn-Button--lg"
              block
              disabled={!validForm}
            >
              Confirmar
            </Button>
            <Button
              lg
              secondary
              type="submit"
              block
              disabled={isDisabled}
              onClick={handleResendToken}
            >
              Reenviar código de verificação
            </Button>
            {isDisabled && (
              <Timer
                timer={30}
                callback={() => setDisabled(false)}
                text="Aguarde %timer% segundos para reenviar o código"
              />
            )}
          </FormActions>
        </Fieldset>
      </form>
      <GenericModal
        showModal={showModal}
        header={<Heading md></Heading>}
        onClose={() => {handleCloseModal();
          tagAdapter({"nome_item":"fechar","nome_modal":nomeModal},TagTypeGa4.BUTTON_MODAL)}}
        content={
          <>
            <Div class="mdn-IconGroup mdn-IconGroup--default">
              <i class="mdn-Icon-minha-claro mdn-Icon--md"></i>
            </Div>
            <Heading tag="h3">
              {' '}
              Você está indo para a área do Meu Perfil
            </Heading>
            <br />
            <Text body>
              Lá você encontrará funcionalidades de gestão do Perfil Claro, sendo essas:
            </Text>
            <br />
            <Text body style={styledP}>
              <i style={styledI} class="mdn-Icon-senha mdn-Icon--md"></i>Senha
              de acesso Claro
            </Text>
            <br />
            <Text body style={styledP}>
              <i style={styledI} class="mdn-Icon-celular mdn-Icon--md"></i>Meus
              números e dependentes
            </Text>
            <br />
            <Text body style={styledP}>
              <i style={styledI} class="mdn-Icon-e-mail mdn-Icon--md"></i>Dados
              de email de acesso
            </Text>
          </>
        }
        footer={
          <>
            <Button
              tagConfig={defaultConfig}
              secondary
              onClick={() => {handleCloseModal()}}
            >
              Voltar
            </Button>
            <Button
              tagConfig={defaultConfig}
              onClick={handleSubmit}
              primary
            >
              Ok, leve-me
            </Button>
          </>
        }
      />
    </>
  );
};

export default TokenValidate;
